export const UPDATEUER = 'UPDATEUER';
export const SETNAVIGATIONTITLE = 'SETNAVIGATIONTITLE';
export const UPDATETOPICCLASS = 'UPDATETOPICCLASS';



// WEBPACK FOOTER //
// ./src/vuex/type.js